<script>
export let src;
export let size = "1em";
export let color = undefined;
export let title = undefined;
export let className = "";

let innerHtml;
let attr;
$: {
  attr = {};
  if (color) {
    if (src.a.stroke !== "none") {
      attr.stroke = color;
    }
    if (src.a.fill !== "none") {
      attr.fill = color;
    }
  }
}

$: {
  innerHtml = (title ? `<title>${title}</title>` : "") + src.c;
}
</script>

<svg
width={size}
height={size}
stroke-width="0"
class={className}
{...src.a}
{...attr}
xmlns="http://www.w3.org/2000/svg">
{@html innerHtml}
</svg>
